import * as types from './actionTypes';
import { getDataColumns, getDataColumnsCustomQueue } from '../api/caseDataAPI';

export function setDataColumnListSuccess(columns, pageId, searchPage) {
  return {
    type: searchPage ? types.SET_APP_SEARCH_DATA_COLUMNS : types.FETCH_DATA_COLUMNS,
    columns,
    pageId,
  };
}

export function fetchDataColumns(pageId, searchPage) {
  return async (dispatch) => {
    try {
      const apiResponse = await getDataColumns(pageId);
      if (apiResponse.status.statusCode === 2000) {
        if (!searchPage) dispatch(setDataColumnListSuccess(mergeActiveAndAvailableColumns(apiResponse.data), pageId));
        else {
          dispatch(setDataColumnListSuccess(mergeActiveAndAvailableColumns(apiResponse.data), pageId, searchPage));
        }
      }
    } catch (error) {
      console.warn('error received while fetching data columns based on queue page', error);
    }
  };
}

export function fetchDataColumnsCustomQueue(pageId, searchPage, customQueueId) {
  return async (dispatch) => {
    try {
      const apiResponse = await getDataColumnsCustomQueue(pageId, customQueueId);
      if (apiResponse.status.statusCode === 2000) {
        if (!searchPage) dispatch(setDataColumnListSuccess(mergeActiveAndAvailableColumns(apiResponse.data), pageId));
        else {
          dispatch(setDataColumnListSuccess(mergeActiveAndAvailableColumns(apiResponse.data), pageId, searchPage));
        }
      }
    } catch (error) {
      console.warn('error received while fetching data columns based on queue page', error);
    }
  };
}

export function mergeActiveAndAvailableColumns(data) {
  const activeColumns = data.activeColumns.map((column) => {
    return { ...column, userIsVisible: true, defaultIsVisible: column.isDefault, isRequired: column.isDefault };
  });
  const availableColumns = data.availableColumns.map((column) => {
    return { ...column, userIsVisible: false, defaultIsVisible: false, isRequired: false };
  });
  return activeColumns.concat(availableColumns);
}
